export const SignInWithEmailMetrics = {
    View: 'View SignInWithMetrics Component',
    ClickContinue: 'Click Continue Button',
    ClickTextbox: 'Click Email Textbox',
    ViewErrorMessage: 'View Error Message',
};
